import { Injectable, signal } from '@angular/core';

export type ToastType = 'info' | 'success' | 'error';

export interface ToastMessage {
  id: number;
  type: ToastType;
  message: string;
}

@Injectable({ providedIn: 'root' })
export class ToastService {
  private nextId = 1;
  readonly messages = signal<ToastMessage[]>([]);

  show(message: string, type: ToastType = 'info', duration = 3800) {
    const id = this.nextId++;
    this.messages.update(items => [...items, { id, type, message }]);
    window.setTimeout(() => this.dismiss(id), duration);
  }

  info(message: string) {
    this.show(message, 'info');
  }

  success(message: string) {
    this.show(message, 'success');
  }

  error(message: string) {
    this.show(message, 'error', 5200);
  }

  dismiss(id: number) {
    this.messages.update(items => items.filter(item => item.id !== id));
  }
}
